import React from 'react'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { Link } from '@morningtrain/react-navigation'
import WithModelValue from 'support/utilities/WithModelValue'
import moment from 'moment'

export default function RevenueTable ({ isHourly }) {
  return (
    <Table
      striped
      footer={(
        <tr>
          <Columns.Column>
            <Translation name='generic.total' />
          </Columns.Column>
          <Columns.Column alignment='right'>
            <UI.PipedValues secondary={<Displays.AggregateRatio name='midday' outOfName='total_revenue' display={<Displays.Percentage decimals={2} />} />}>
              <Displays.Aggregate name='midday' display={<Displays.Currency />} />
            </UI.PipedValues>
          </Columns.Column>
          <Columns.Column alignment='right'>
            <UI.PipedValues secondary={<Displays.AggregateRatio name='takeaway' outOfName='total_revenue' display={<Displays.Percentage decimals={2} />} />}>
              <Displays.Aggregate name='takeaway' display={<Displays.Currency />} />
            </UI.PipedValues>
          </Columns.Column>
          <Columns.Column alignment='right'>
            <UI.PipedValues secondary={<Displays.AggregateRatio name='bar_revenue' outOfName='total_revenue' display={<Displays.Percentage decimals={2} />} />}>
              <Displays.Aggregate name='bar_revenue' display={<Displays.Currency />} />
            </UI.PipedValues>
          </Columns.Column>
          <Columns.Column alignment='right'>
            <UI.PipedValues secondary={<Displays.AggregateRatio name='kitchen_revenue' outOfName='total_revenue' display={<Displays.Percentage decimals={2} />} />}>
              <Displays.Aggregate name='kitchen_revenue' display={<Displays.Currency />} />
            </UI.PipedValues>
          </Columns.Column>
          <Columns.Aggregate
            alignment='right'
            name='total_revenue'
            display={<Displays.Currency />}
          />
        </tr>
    )}
    >
      {isHourly
        ? (
          <Columns.Column
            name='paid_on'
            label={<Translation name='generic.unspecified_time' />}
          >
            <UI.Text weight='medium'>
              <Displays.HourRange name='paid_on' />
            </UI.Text>
          </Columns.Column>
          )
        : (
          <Columns.Column
            name='paid_on'
            label={<Translation name='generic.weekday' />}
          >
            <WithModelValue name='paid_on'>
              {paidOn => (
                <Link route='app.economy.revenue' parameters={{ date: moment(paidOn).format('YYYY-MM-DD') }} disableRouting>
                  <UI.Text weight='medium'>
                    <Displays.Weekday name='paid_on' />
                  </UI.Text>
                </Link>
              )}
            </WithModelValue>
          </Columns.Column>
          )}
      <Columns.Column
        name='midday'
        alignment='right'
        label={<Translation name='columns.midday.label' />}
      >
        <UI.PipedValues secondary={<Displays.Percentage name='midday_percentage' decimals={2} defaultValue={0} />}>
          <Displays.Currency name='midday' defaultValue={0} />
        </UI.PipedValues>
      </Columns.Column>
      <Columns.Column
        alignment='right'
        name='takeaway'
        label={<Translation name='columns.takeaway.label' />}
      >
        <UI.PipedValues secondary={<Displays.Percentage name='takeaway_percentage' decimals={2} defaultValue={0} />}>
          <Displays.Currency name='takeaway' defaultValue={0} />
        </UI.PipedValues>
      </Columns.Column>
      <Columns.Column
        alignment='right'
        name='bar_revenue'
        label={<Translation name='generic.bar' />}
      >
        <UI.PipedValues secondary={<Displays.Percentage name='bar_percentage' decimals={2} defaultValue={0} />}>
          <Displays.Currency name='bar_revenue' defaultValue={0} />
        </UI.PipedValues>
      </Columns.Column>
      <Columns.Column
        alignment='right'
        name='kitchen_revenue'
        label={<Translation name='generic.kitchen' />}
      >
        <UI.PipedValues secondary={<Displays.Percentage name='kitchen_percentage' decimals={2} defaultValue={0} />}>
          <Displays.Currency name='kitchen_revenue' defaultValue={0} />
        </UI.PipedValues>
      </Columns.Column>
      <Columns.Currency
        alignment='right'
        name='total_revenue'
        label={<Translation name='generic.total' />}
      />
    </Table>
  )
}
